import { Link } from 'react-router-dom';

import { useSite } from '../context/SiteProvider.jsx';
import { usePageMeta } from '../hooks/usePageMeta.js';
import { Reveal } from '../components/common/Reveal.jsx';
import { RichText } from '../components/common/RichText.jsx';

export default function NotFound() {
  const { t } = useSite();
  usePageMeta('404');

  return (
    <main id="main">
      <section className="not-found section-pad">
        <Reveal className="not-found-copy">
          <p className="eyebrow">404</p>
          <RichText as="h2" html={t('notFoundTitle')} />
          <p>{t('notFoundText')}</p>
          <div className="hero-buttons">
            <Link className="button dark" to="/">
              <span>{t('backHome')}</span>
              <span>↗</span>
            </Link>
            <Link className="button line" to="/shop">
              <span>{t('navShop')}</span>
              <span>↗</span>
            </Link>
          </div>
        </Reveal>
      </section>
    </main>
  );
}
